// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.View_header__JmPf\\+ {
  font-weight: bold;
}

.View_subHeader__yKYTr {
  font-size: 0.8rem;
}

.View_reservationImages__LVh00 {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
}

.View_reservationImage__ddtIW {
  display: block;
  height: 120px;
  overflow: hidden;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  background: #f8f9fa;
}
.View_reservationImage__ddtIW img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.2s ease;
}
.View_reservationImage__ddtIW:hover img {
  transform: scale(1.04);
}

.View_reservationImageWrapper__\\+G4Qp {
  position: relative;
}

.View_removeReservationImage__srfXj {
  position: absolute;
  top: 0.4rem;
  right: 0.4rem;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.35);
}

.View_commentBox__EVNkY {
  background: #f8f9fc;
  border: 1px solid #e3e6f0;
  border-left: 4px solid #545cd8;
  border-radius: 0.35rem;
  padding: 0.85rem 1rem;
}

.View_commentLabel__iWe1V {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0;
}

.View_commentText__2jQ1m {
  font-size: 0.85rem;
  white-space: pre-wrap;
  word-break: break-word;
  margin: 0.5rem 0 0;
}

.View_commentEmpty__tfG8j {
  font-size: 0.85rem;
  font-style: italic;
  color: #9095a5;
  margin: 0.5rem 0 0;
}

.View_section__EuwOx {
  padding-bottom: 1.25rem;
  margin-bottom: 1.25rem;
  border-bottom: 1px solid #e9ecef;
}
.View_section__EuwOx:last-child {
  padding-bottom: 0;
  margin-bottom: 0;
  border-bottom: none;
}

.View_sectionTitle__\\+Qu3v {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #8790a3;
  margin-bottom: 0.85rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Reservations/styles/View.module.scss"],"names":[],"mappings":"AAAA;EACI,SAAA;EACA,UAAA;EACA,sBAAA;AACJ;;AACA;EACI,iBAAA;AAEJ;;AACA;EACI,iBAAA;AAEJ;;AACA;EACI,aAAA;EACA,4DAAA;EACA,cAAA;EAAA,SAAA;AAEJ;;AACA;EACI,cAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;AAEJ;AAAI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,+BAAA;AAER;AACI;EACI,sBAAA;AACR;;AAGA;EACI,kBAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,yCAAA;AAAJ;;AAGA;EACI,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,sBAAA;EACA,qBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,uBAAA;EACA,sBAAA;EACA,gCAAA;AAAJ;AAEI;EACI,iBAAA;EACA,gBAAA;EACA,mBAAA;AAAR;;AAIA;EACI,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,sBAAA;AADJ","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n.header {\n    font-weight: bold;\n}\n\n.subHeader {\n    font-size: 0.8rem;\n}\n\n.reservationImages {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n    gap: 1rem;\n}\n\n.reservationImage {\n    display: block;\n    height: 120px;\n    overflow: hidden;\n    border: 1px solid #dee2e6;\n    border-radius: 0.25rem;\n    background: #f8f9fa;\n\n    img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n        transition: transform 0.2s ease;\n    }\n\n    &:hover img {\n        transform: scale(1.04);\n    }\n}\n\n.reservationImageWrapper {\n    position: relative;\n}\n\n.removeReservationImage {\n    position: absolute;\n    top: 0.4rem;\n    right: 0.4rem;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.35);\n}\n\n.commentBox {\n    background: #f8f9fc;\n    border: 1px solid #e3e6f0;\n    border-left: 4px solid #545cd8;\n    border-radius: 0.35rem;\n    padding: 0.85rem 1rem;\n}\n\n.commentLabel {\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n    margin-bottom: 0;\n}\n\n.commentText {\n    font-size: 0.85rem;\n    white-space: pre-wrap;\n    word-break: break-word;\n    margin: 0.5rem 0 0;\n}\n\n.commentEmpty {\n    font-size: 0.85rem;\n    font-style: italic;\n    color: #9095a5;\n    margin: 0.5rem 0 0;\n}\n\n.section {\n    padding-bottom: 1.25rem;\n    margin-bottom: 1.25rem;\n    border-bottom: 1px solid #e9ecef;\n\n    &:last-child {\n        padding-bottom: 0;\n        margin-bottom: 0;\n        border-bottom: none;\n    }\n}\n\n.sectionTitle {\n    font-size: 0.72rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: #8790a3;\n    margin-bottom: 0.85rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `View_header__JmPf+`,
	"subHeader": `View_subHeader__yKYTr`,
	"reservationImages": `View_reservationImages__LVh00`,
	"reservationImage": `View_reservationImage__ddtIW`,
	"reservationImageWrapper": `View_reservationImageWrapper__+G4Qp`,
	"removeReservationImage": `View_removeReservationImage__srfXj`,
	"commentBox": `View_commentBox__EVNkY`,
	"commentLabel": `View_commentLabel__iWe1V`,
	"commentText": `View_commentText__2jQ1m`,
	"commentEmpty": `View_commentEmpty__tfG8j`,
	"section": `View_section__EuwOx`,
	"sectionTitle": `View_sectionTitle__+Qu3v`
};
export default ___CSS_LOADER_EXPORT___;
